import React, { useEffect, useRef, useState } from 'react'
import { CountrySelectorOption, Props } from './paywall';
import { Typography } from '../../../react/components/typography/typography';
import { Button } from '../../../react/components/button/button';
import style from './geoblock.module.scss'

export default function Geoblock ({
  geo_country,
  country_selector_options,
  onClickContinue,
  onClickGoToReadlyGeo,
  translations,
}: {
  geo_country: string;
  country_selector_options: CountrySelectorOption[],
  onClickContinue: () => void,
  onClickGoToReadlyGeo: () => void,
  translations: string[],
}) {
  const countries = country_selector_options.map((c) => c.text);

  const origin = `${location.origin}`.replace(/(:\/\/\w+\.)/, `://${geo_country}.`);
  const formattedCountries = (() => {
    if (countries.length === 1) {
      return countries[0]
    } else {
      return countries.slice(0, -1).join(', ')+' & '+countries.slice(-1);
    }
  })()

  return (
    <div style={{width: '100%', padding: '32px 0'}}>
      <div style={{margin: '0 auto', maxWidth: '482px', width: '100%', padding: '0 16px'}}>
        <Typography element='p' textSize='sys-title-medium' themeColor='text-ink-offset'>
        {translations['lokalise.catalog.article_paywall.geo.description'].replace("%{countries}", formattedCountries)}
        </Typography>
        
        <div className={style.buttonContainer}>
          <Button buttonSize="large" buttonStyle='outline' theme='light' element='a' href={origin} onClick={onClickGoToReadlyGeo}>
            {translations['lokalise.catalog.article_paywall.geo.visit_readly_geo_country'].replace("%{country}", geo_country)}
          </Button>

          <Button buttonSize="large" buttonStyle='primary' theme='light' element='button' href={origin} onClick={onClickContinue}>
            {translations['lokalise.catalog.article_paywall.geo.continue']}
          </Button>
        </div>
      </div>
    </div>
  );
}
